<!-- IDS are hardcoded already -->

<div class="reset-password" fxLayout="column" fxLayoutAlign="space-between center" fxFlexFill>
  
  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
    <mat-card class="padding-25 mat-elevation-z5" fxFlex="370px" fxFlex.lt-sm="90%">
      <form [formGroup]="resetPasswordForm" fxLayout="column" (ngSubmit)="resetPasswordForm.valid && onSubmit(resetPasswordForm.value)" autocomplete="off" autocorrect="off" fxLayoutGap="25px" novalidate>

        <!--Image Logo-->
        <img id="id_reset_password_img_cfs_logo" class="logo" [src]="imgUrl" alt="E-Science Logo">

        <!--Statement Logo-->
        <!-- <h2 class="mat-display-1 mat-primary-color">E-Science Corporation</h2> -->

        <mat-label id="id_reset_password_lbl_error" class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
          {{errorMessage}}
        </mat-label>

        <mat-form-field>
          <input matInput 
            id="id_reset_password_txt_username"
            [placeholder]="'USERNAME' | translate" 
            formControlName="username">
          <mat-error id="id_reset_password_txt_username_error_required" *ngIf="resetPasswordForm.controls['username'].hasError('required')">
            {{ 'MESSAGE_ERROR_USERNAME_REQUIRED' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_txt_username_error_not_existing" *ngIf="resetPasswordForm.controls['username'].hasError('notExisting')">
            {{ 'MESSAGE_ERROR_USERNAME_NOT_EXISTING' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_txt_username_error_whitespace" *ngIf="resetPasswordForm.controls['username'].hasError('whitespace')">
            {{ 'MESSAGE_ERROR_INVALID_USERNAME' | translate }}
          </mat-error>
        </mat-form-field>
        
        <mat-form-field fxFlex>
          <input matInput 
            id="id_reset_password_txt_verification_code"
            maxlength="6" 
            [placeholder]="'VERIFICATION_CODE' | translate" 
            formControlName="code">
          <button fxFlex matSuffix mat-button 
            id="id_reset_password_btn_resend_verification_code"
            [disabled]="resetPasswordForm.controls['username'].invalid"
            (click)="resendVerificationCode(resetPasswordForm.value)"
            type="button"
            color="primary" 
            >
            {{ (isResendingCode ? 'RESENDING' : 'RESEND') | translate }}
          </button>
          <mat-error id="id_reset_password_lbl_verification_code_error_required" *ngIf="resetPasswordForm.controls['code'].hasError('required')">
            {{ 'MESSAGE_ERROR_VERIFICATION_CODE_REQUIRED' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_verification_code_error_incorrect" *ngIf="resetPasswordForm.controls['code'].hasError('codeMismatch')">
            {{ 'MESSAGE_ERROR_VERIFICATION_CODE_INCORRECT' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_verification_code_error_whitespace" *ngIf="resetPasswordForm.controls['code'].hasError('whitespace')">
            {{ 'MESSAGE_ERROR_INVALID_CODE' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput 
            id="id_reset_password_txt_password"
            [placeholder]="'NEW_PASSWORD'| translate" 
            minlength="8" 
            maxlength="60" 
            [type]="show.password ? 'text' : 'password'"
            formControlName="password">
          <mat-icon *ngIf="resetPasswordForm.controls['password'].value" 
            id="id_reset_password_btn_password_mask"
            matSuffix 
            (click)="show.password = !show.password"
            [svgIcon]="show.password ? 'eye-off' : 'eye'">
          </mat-icon>
          <mat-error id="id_reset_password_lbl_password_error_required" *ngIf="resetPasswordForm.controls['password'].hasError('required')">
            {{ 'MESSAGE_ERROR_PASSWORD_REQUIRED' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_password_error_min_length" *ngIf="resetPasswordForm.controls['password'].hasError('minlength')">
            {{ 'MESSAGE_ERROR_PASSWORD_MIN_LENGTH' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_password_error_max_length" *ngIf="resetPasswordForm.controls['password'].hasError('maxlength')">
            {{ 'MESSAGE_ERROR_PASSWORD_MAX_LENGTH' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_password_error_pattern" *ngIf="resetPasswordForm.controls['password'].hasError('pattern')">
            {{ 'MESSAGE_ERROR_PASSWORD_PATTERN' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_password_error_invalid" *ngIf="resetPasswordForm.controls['password'].hasError('invalidPassword')">
            {{ 'MESSAGE_ERROR_INVALID_PASSWORD' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_password_error_match" *ngIf="resetPasswordForm.controls['password'].hasError('matchPassword')">
            {{ 'MESSAGE_ERROR_SAME_LAST_PASSWORD' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput 
            id="id_reset_password_txt_cpassword"
            [placeholder]="'CONFIRM_PASSWORD' | translate" 
            [type]="show.confirm ? 'text' : 'password'"
            formControlName="confirmPassword">
          <mat-icon 
            id="id_reset_password_btn_cpassword_mask"
            *ngIf="resetPasswordForm.controls['confirmPassword'].value" 
            matSuffix 
            (click)="show.confirm = !show.confirm"
            [svgIcon]="show.confirm ? 'eye-off' : 'eye'">
          </mat-icon>
          <mat-error id="id_reset_password_lbl_cpassword_error_required" *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('required')">
            {{ 'MESSAGE_ERROR_PASSWORD_REQUIRED' | translate }}
          </mat-error>
          <mat-error id="id_reset_password_lbl_cpassword_error_incorrect" *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('matchPassword')">
            {{ 'MESSAGE_ERROR_INCORRECT_CONFIRM_PASSWORD' | translate}}
          </mat-error>
        </mat-form-field>

        <button id="id_reset_password_btn_reset_password" color="primary" [disabled]="isSubmitting" mat-raised-button type="submit">
          {{ (isSubmitting ? 'RESETTING_PASSWORD' : 'RESET_PASSWORD') | translate }}
        </button>

        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center">
          <button fxFlex mat-button 
            id="id_reset_password_back"
            type="button"
            routerLink="../login" 
            [queryParams]="resetPasswordForm.controls['username'].valid ? { username: resetPasswordForm.controls['username'].value } : {}"
            color="primary">
            {{ 'RETURN_TO_LOGIN' | translate }}
          </button>
        </div>

      </form>
    </mat-card>
  </div>
  <div fxFlexAlign="end">
    <esc-footer></esc-footer>
  </div>
</div>